import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sm-calender-dialog-for-booking',
  templateUrl: './calender-dialog-for-booking.component.html',
  styleUrls: ['./calender-dialog-for-booking.component.scss']
})
export class CalenderDialogForBookingComponent implements OnInit {
  selectedDate: Date | null = null;   // bound to [(selected)]
  startAt: Date | null = null;        // replace activeDate with startAt
minDate: Date = new Date()
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private calDialogRef: MatDialogRef<CalenderDialogForBookingComponent>
  ) {}

  ngOnInit(): void {
    this.startAt = this.data?.selectedDate ?? new Date();
    this.selectedDate = null; // so clicking the same date will trigger selectedChange
  }

  onDateSelection(date: Date) {
    this.calDialogRef.close(date);
  }
}

